var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.authStateChecked || _vm.dashboardNotRendered)?_c('div',{staticClass:"app__loading"},[_c('img',{attrs:{"src":require("@/assets/imgs/gifs/loading.gif"),"alt":"loading..."}})]):_vm._e(),_vm._v(" "),(_vm.authStateChecked)?_c('router-view'):_vm._e(),_vm._v(" "),_c('InProcess'),_vm._v(" "),_c('Errors')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b68515fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 